import * as angular from 'angular';
import './PriorityRuleItem.scss';
import { QueueManagementConstants } from '../../queueManagement/QueueManagementConstants';
import { PriorityTracks } from '../PriorityTracksConstants';
export class PriorityRuleItemController {
    static $inject = ['$translate', 'ngToast', 'PriorityLoadValues', 'SegmentService'];
    constructor($translate, ngToast, PriorityLoadValues, SegmentService) {
        'ngInject';
        this.$translate = $translate;
        this.ngToast = ngToast;
        this.PriorityLoadValues = PriorityLoadValues;
        this.SegmentService = SegmentService;
        this.elementId = 'priority-rule';
        this.onPriorityToggle = async () => {
            const value = !this.priority.isActive;
            this.data.isActive = value;
            await this.onToggle({ $priority: this.data });
            const trackToggle = value ? PriorityTracks.PRIORITY_RULE_ENABLED : PriorityTracks.PRIORITY_RULE_DISABLED;
            this.SegmentService.createBotTrack(trackToggle, this.application);
        };
        this.onChangeOperator = async (event) => {
            if (!this.isUserCanEdit()) {
                this.priority = angular.copy(this.data);
                this.priority.repeatConditionsBody = this.priority.conditions.length > 1;
                return;
            }
            if (event?.detail?.value && this.priority.operator !== event.detail.value) {
                this.priority.operator = event.detail?.value;
                this.expandableBodyText = await this.translateOperator();
                this.operatorText = await this.translateOperatorText();
                await this.tryEditRule();
            }
        };
        this.onChangeUrgency = async (event) => {
            if (!this.isUserCanEdit()) {
                this.priority = angular.copy(this.data);
                this.priority.repeatConditionsBody = this.priority.conditions.length > 1;
                return;
            }
            if (!event || this.priority.operator === event.detail?.value) {
                return;
            }
            else {
                this.priority.urgency = event.detail?.value;
            }
            await this.tryEditRule();
        };
        this.tryEditRule = async () => {
            try {
                if (this.onEdit) {
                    await this.onEdit({ $priority: this.priority });
                }
            }
            catch (e) {
                this.ngToast.warning(this.$translate.instant('attendance-priority-rules.errors.warning'));
            }
            finally {
                this.isLoading = false;
            }
        };
        this.applyConditionsCheckbox = async (event) => {
            if (this.priority) {
                this.priority.applyConditions = !this.priority.applyConditions;
                this.canEditConditions = this.getCanEditConditions();
                this.priority.valuesEmpty = this.isAnyValueEmpty();
            }
        };
        this.changeTitle = (event) => {
            const title = event?.detail?.value ?? '';
            this.priority.title = title;
        };
        this.showNoPermissionAlert = async () => {
            this.ngToast.warning(this.$translate.instant('attendance-priority-rules.errors.cannotEdit'));
        };
    }
    async $onInit() {
        this.priority = angular.copy(this.data);
        this.expandableBodyText = await this.translateOperator();
        this.operatorText = await this.translateOperatorText();
        this.urgencyDegrees = await this.PriorityLoadValues.loadUrgencyDegrees();
        this.canEditConditions = this.getCanEditConditions();
    }
    $deleteModel() {
        if (!this.canEditRule) {
            return;
        }
        this.onDelete({ $item: this.priority });
    }
    $cancelModel() {
        this.onCancel();
        this.data.opened = false;
        this.priority = angular.copy(this.data);
        this.canEditConditions = this.getCanEditConditions();
    }
    onCloseRule() {
        this.priority.opened = false;
        this.data = this.priority;
        if (this.close) {
            this.close();
        }
    }
    onOpenPriorityRuleChild() {
        this.priority.opened = true;
        this.data = this.priority;
        this.onOpenPriorityRule();
        this.priority = angular.copy(this.data);
        if (!this.canEditRule) {
            this.showNoPermissionAlert();
        }
    }
    isUserCanEdit() {
        if (!this.canEditRule) {
            this.showNoPermissionAlert();
            return false;
        }
        return true;
    }
    async updatePriorityRule() {
        if (!this.isUserCanEdit()) {
            return;
        }
        this.priority.opened = false;
        try {
            if (this.onSave) {
                await this.onSave({ $priority: this.priority });
            }
        }
        catch (e) {
            this.ngToast.warning(this.$translate.instant('attendance-priority-rules.errors.warning'));
        }
        finally {
            this.isLoading = false;
            const trackSave = this.currentState === QueueManagementConstants.STATES.ADDING ? PriorityTracks.PRIORITY_RULE_ADDED : PriorityTracks.PRIORITY_RULE_EDITED;
            this.SegmentService.createBotTrack(trackSave, this.application);
        }
    }
    async translateOperator() {
        return this.operators?.find(op => op.value === this.priority.operator).label || '';
    }
    getPriorityUrgencyLabel() {
        return this.urgencyDegrees?.find(x => x.value == this.priority.urgency.toString()).label;
    }
    async translateOperatorText() {
        if (this.priority.operator === 'Or') {
            return await this.$translate('attendance-priority-rules.conditionsHeaderTextOr');
        }
        else if (this.priority.operator === 'And') {
            return await this.$translate('attendance-priority-rules.conditionsHeaderTextAnd');
        }
    }
    getCanEditConditions() {
        return this.canEditRule && this.priority.applyConditions;
    }
    async addCondition() {
        this.priority.repeatConditionsBody = true;
        this.priority.operator = this.priority.operator || QueueManagementConstants.DEFAULT_OPERATOR;
        this.expandableBodyText = await this.translateOperator();
        this.priority.conditions[this.priority.conditions.length] = {
            property: 'Message',
            relation: 'Contains',
            values: [],
            extrasProperty: '',
        };
        this.priority.valuesEmpty = this.isAnyValueEmpty();
        await this.tryEditRule();
        this.SegmentService.createBotTrack(PriorityTracks.PRIORITY_CONDITION_ADDED, this.application);
    }
    async removeCondition(conditionIndex) {
        this.priority.operator = this.priority.operator ?? QueueManagementConstants.DEFAULT_OPERATOR;
        this.priority.conditions.splice(conditionIndex, 1);
        this.priority.conditions = this.priority.conditions.filter(val => val);
        this.priority.repeatConditionsBody = this.priority.conditions.length > 1;
        await this.tryEditRule();
        this.SegmentService.createBotTrack(PriorityTracks.PRIORITY_CONDITION_DELETED, this.application);
    }
    async updateCondition(condition, index) {
        this.priority.conditions[index] = condition;
        this.priority.operator = this.priority.operator ?? QueueManagementConstants.DEFAULT_OPERATOR;
        this.priority.valuesEmpty = this.isAnyValueEmpty();
        await this.tryEditRule();
        this.SegmentService.createBotTrack(PriorityTracks.PRIORITY_CONDITION_UPDATED, this.application);
    }
    isAnyValueEmpty() {
        return !this.priority.conditions.every(condition => {
            return condition.property.includes('Extras')
                ? condition.property && condition.extrasProperty && condition.relation && condition.values.length && this.priority.title
                : condition.property && condition.relation && condition.values.length && this.priority.title;
        });
    }
}
PriorityRuleItemController.$inject = ['$translate', 'ngToast', 'PriorityLoadValues', 'SegmentService'];
